import { z } from "zod";
import { contractorSchema } from "../../contractors";
import { employeeSchema } from "../../employees/schemas/baseEmployee";
import { schemes } from "../../schema-validation";
import { InstrumentOwnerType } from "../InstrumentOwnerType";
import { TransactionConnectionType } from "../TransactionConnectionType";
import { TransactionMethod } from "../TransactionMethod";
import { TransactionStatus } from "../TransactionStatus";
import { TransactionType } from "../TransactionType";
import { transactionEventSchema } from "./transactionEventSchema";
import { companySchema } from "../../companies/schemas/company.schema";
import { WalletTransferType } from "../WalletTransferType";

export const transactionSchema = z.object({
  amount: z.number(),
  chargeID: schemes.uuid().optional(),
  companyID: schemes.companyID(),
  company: companySchema.optional(),
  contractor: contractorSchema.optional(),
  destination_instrument: z.object({
    bankAccountID: schemes.uuid().optional(),
    cardDetails: z
      .object({
        card_company: z.string(),
        cardID: z.string(),
        first_name: z.string(),
        last_name: z.string(),
        last_four: z.string(),
      })
      .optional(),
    bankAccountDetails: z
      .object({
        type: z.string(),
        bankAccountID: z.string(),
        last_four: z.string(),
        destinationID: z.string().optional(),
      })
      .optional(),
    last_four: z.string().optional(),
    owner_type: z.nativeEnum(InstrumentOwnerType),
    paycardID: schemes.uuid().optional(),
    walletID: schemes.uuid().optional(),
  }),
  employee: employeeSchema.optional(),
  external_note: z.string().nullable().optional(),
  method: z.nativeEnum(TransactionMethod),
  retry: z.boolean().default(false),
  source_instrument: z.object({
    card_details: z.object({}).optional(),
    bankAccountID: schemes.uuid().optional(),
    last_four: z.string().optional(),
    owner_type: z.nativeEnum(InstrumentOwnerType),
    paycardID: schemes.uuid().optional(),
    wire_details: z.object({}).optional(),
  }),
  status: z.nativeEnum(TransactionStatus).optional(),
  traceID: z.string().optional(),
  transaction_events: z.array(transactionEventSchema),
  transaction_type: z.nativeEnum(TransactionType),
  transaction_connections: z.array(
    z.object({
      connectionID: schemes.uuid(),
      transactionID: schemes.uuid(),
      type: z.nativeEnum(TransactionConnectionType),
    })
  ),
  transactionID: schemes.uuid(),
  transfer_type: z.nativeEnum(WalletTransferType).optional(),
});

export type TTransaction = z.infer<typeof transactionSchema>;
